import { get2bapReportsModuleUrl } from './getUrls';
import { loader } from './loader';
import routerUtility from 'utils/routerUtility';
import ModuleAccessCodes from '../../../../constants/moduleCodes';

export default {
  
  path: get2bapReportsModuleUrl(),
  
  getIndexRoute(partialNextState, callback) {
    require.ensure([], (require) => {
      callback(null, { component: require('./views/ReportsPage').default, }, '2bap');
    })
  },
  
  getComponent(nextState, callback) {
    const error = routerUtility.getAccessError(ModuleAccessCodes.MODULE_2BAP);
    if (error) {
      callback(error);
      return;
    }
    
    loader(callback);
  }
  
}
